import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import styled from 'styled-components';
import { TOOLBAR_HEIGHT } from '../../constants/Dimensions';
import { getDetailHeaderStyles } from '../../unified-inbox/components/DetailHeaderWrapper';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { H7 } from 'foundations-components/transitional/components/H7';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BatchColumnHeader = styled.div.withConfig({
  displayName: "AsyncBatchThreadOperationsToolbarContainerError__BatchColumnHeader",
  componentId: "sc-1rqu6ay-0"
})(({
  theme
}) => getDetailHeaderStyles(theme, {
  insetBlockStart: 0,
  insetInlineStart: 0,
  insetInlineEnd: 0,
  paddingBlock: 0,
  paddingInline: 18,
  position: 'absolute'
}));
BatchColumnHeader.displayName = 'BatchColumnHeader';
const AsyncBatchThreadOperationsToolbarContainerError = ({
  retry
}) => {
  return /*#__PURE__*/_jsx(BatchColumnHeader, {
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      blockSize: `${TOOLBAR_HEIGHT}px`,
      children: [/*#__PURE__*/_jsx(H7, {
        marginBlockEnd: "0",
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.code-splitting.error.title"
        })
      }), /*#__PURE__*/_jsx(View, {
        as: "span",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.code-splitting.error.message"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        size: "xs",
        marginInlineStart: "200",
        onClick: retry,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.code-splitting.error.button"
        })
      })]
    })
  });
};
AsyncBatchThreadOperationsToolbarContainerError.displayName = 'AsyncBatchThreadOperationsToolbarContainerError';
export default AsyncBatchThreadOperationsToolbarContainerError;